import buildResourceActions from 'store/configure/actions'

const resourceActions = buildResourceActions('bookeePaymentCapabilitiesV2')

export default resourceActions
